export const SCRAPER_SHORT_NAME_MAX_LENGTH = 32

const SCRAPER_SHORT_NAME_PATTERN = /^[a-z0-9-]+$/

/** Mirrors backend normalizeScraperShortName in king-monorepo scraper-short-name.util.ts */
export function normalizeScraperShortName(input: string): string {
    const normalized = input
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, SCRAPER_SHORT_NAME_MAX_LENGTH)

    return normalized === '' ? 'default' : normalized
}

/** Mirrors backend isValidScraperShortName in king-monorepo scraper-short-name.util.ts */
export function isValidScraperShortName(input: string): boolean {
    const trimmed = input.trim()
    const normalized = normalizeScraperShortName(trimmed)
    return normalized === trimmed.toLowerCase() && normalized !== 'default'
}

export function getScraperShortNameValidationError(value: string): string | null {
    const trimmed = value.trim()

    if (trimmed === '') {
        return 'This field is required'
    }

    if (!SCRAPER_SHORT_NAME_PATTERN.test(trimmed)) {
        return 'Use lowercase letters, numbers, and hyphens only'
    }

    if (trimmed.length > SCRAPER_SHORT_NAME_MAX_LENGTH) {
        return `Short name must be at most ${SCRAPER_SHORT_NAME_MAX_LENGTH} characters`
    }

    if (normalizeScraperShortName(trimmed) === 'default') {
        return 'Short name must contain at least one letter or number'
    }

    if (!isValidScraperShortName(trimmed)) {
        return 'Remove leading, trailing, or repeated hyphens'
    }

    return null
}
